// src/components/Contact/ContactUs.js

import React from "react";
import "../../styles/ijrr.css";

export default function ContactUs() {
  return (
    <section className="contact-us-section space-pb-80">
      <div className="container">
        <div className="row justify-content-center text-center">
          {/* Headquarters Box */}
          <div className="col-lg-4 col-md-6">
            <div className="contact-box">
              <div className="icon-wrap large-icon">
                <i className="icofont-ship"></i>
              </div>
              <h4 className="ijrr-title">Where to Find Us</h4>
              <p>Always on the move </p>
            </div>
          </div>

          {/* Email Box */}
          <div className="col-lg-4 col-md-6">
            <div className="contact-box">
              <div className="icon-wrap large-icon">
                <i className="icofont-email"></i>
              </div>
              <h4 className="ijrr-title">Send a Message</h4>
              <p>
                <a href="mailto:info@myjollyroger.com" className="ijrr-link">
                  info@myjollyroger.com
                </a>
              </p>
            </div>
          </div>

          {/* Office Time */}
          <div className="col-lg-4 col-md-6">
            <div className="contact-box">
              <div className="icon-wrap large-icon">
                <i className="icofont-ui-timer"></i>
              </div>
              <h4 className="ijrr-title">Deck Hours</h4>
              <p>Mon - Fri: 9:00 am – 5:00 pm</p>
              <p>Saturday & Sunday: Out sailing </p>
            </div>
          </div>
        </div>

        {/* Contact Form */}
        <div className="row justify-content-center mt-5">
          <div className="col-lg-8">
            <div className="contact-group">
              <form>
                <div className="group-form">
                  <div className="group-small">
                    <div>
                      <input className="form-control" type="text" placeholder="First Name" />
                    </div>
                    <div>
                      <input className="form-control" type="number" placeholder="Phone Number" />
                    </div>
                  </div>
                </div>
                <div className="group-form">
                  <div className="group-small">
                    <div>
                      <input className="form-control" type="email" placeholder="E-mail" />
                    </div>
                    <div>
                      <input className="form-control" type="text" placeholder="Subject" />
                    </div>
                  </div>
                </div>
                <div className="group-form">
                  <textarea className="form-control" placeholder="Write Your Message" name="message"></textarea>
                </div>
                <div className="group-form mb-0 text-center">
                  <button type="submit" className="btn btn-primary">
                    Drop Anchor with a Message
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}